.alertIcon {
  fill: var(--tractie-color-content-warning);
  stroke: var(--tractie-color-background-elevated-2);
  stroke-width: 2;
  stroke-linejoin: round;
  paint-order: stroke;
  height: 16px;
  width: 16px;
}
